// Registry of ALL editable content fields, organised by page and section.

export const PAGES = [
  {
    slug: "global",
    label: "Identité & navigation",
    description: "Logo, menu, pied de page, boutons globaux.",
    sections: [
      {
        name: "Logo & identité",
        fields: [
          { key: "global.logo", label: "Logo du site (header & footer)", type: "image", default: "/assets/logo.png" },
          { key: "global.linkedin.url", label: "URL LinkedIn du cabinet", type: "text", default: "https://www.linkedin.com/in/michelo-nuzzo-bba449105/" },
        ],
      },
      {
        name: "Menu principal",
        fields: [
          { key: "nav.home", label: "Lien — Accueil", type: "text", default: "Accueil" },
          { key: "nav.assurances", label: "Lien — Assurances pro", type: "text", default: "Assurances pro" },
          { key: "nav.sante", label: "Lien — Santé & prévoyance", type: "text", default: "Santé & prévoyance" },
          { key: "nav.patrimoine", label: "Lien — Patrimoine & placements", type: "text", default: "Patrimoine & placements" },
          { key: "nav.methode", label: "Lien — Méthode", type: "text", default: "Méthode" },
          { key: "nav.partenaires", label: "Lien — Partenaires", type: "text", default: "Partenaires" },
          { key: "nav.contact", label: "Lien — Contact", type: "text", default: "Contact" },
          { key: "header.cta", label: "Bouton CTA du header", type: "text", default: "Être rappelé" },
        ],
      },
      {
        name: "Pied de page",
        fields: [
          { key: "footer.tagline", label: "Texte descriptif", type: "textarea", default: "Cabinet de courtage indépendant à Dijon. Conseil sur mesure en assurance, protection sociale, patrimoine et placements — pour particuliers, indépendants, dirigeants et entreprises." },
          { key: "footer.location", label: "Localisation", type: "text", default: "Dijon, Bourgogne" },
          { key: "footer.email", label: "Email", type: "text", default: "contact@courtagedesducs.fr" },
          { key: "footer.phone", label: "Téléphone / disponibilité", type: "text", default: "Sur rendez-vous" },
          { key: "footer.col1.title", label: "Colonne 1 — titre", type: "text", default: "Solutions" },
          { key: "footer.col2.title", label: "Colonne 2 — titre", type: "text", default: "Cabinet" },
          { key: "footer.copyright", label: "Mention copyright (laisser vide pour générique)", type: "text", default: "" },
        ],
      },
    ],
  },

  {
    slug: "home",
    label: "Accueil",
    description: "Page principale du site.",
    sections: [
      {
        name: "Hero (en-tête)",
        fields: [
          { key: "home.hero.image", label: "Image de fond", type: "image", default: "https://images.unsplash.com/photo-1773678401653-6722e9026d22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxkaWpvbiUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjByb29mfGVufDB8fHx8MTc4MTI3NDU0M3ww&ixlib=rb-4.1.0&q=85" },
          { key: "home.hero.eyebrow", label: "Étiquette localisation", type: "text", default: "Dijon · Bourgogne" },
          { key: "home.hero.title.line1", label: "Titre — ligne 1", type: "text", default: "Conseil patrimonial" },
          { key: "home.hero.title.line2", label: "Titre — ligne 2", type: "text", default: "et courtage indépendant" },
          { key: "home.hero.title.accent", label: "Titre — accent (italique doré)", type: "text", default: "au cœur de Dijon." },
          { key: "home.hero.lead", label: "Paragraphe d'introduction", type: "textarea", default: "Des solutions d'assurance et de placement sur mesure, sélectionnées auprès de partenaires reconnus, avec un accompagnement complet — de l'audit à la mise en place." },
          { key: "home.hero.cta1", label: "Bouton primaire", type: "text", default: "Demander un audit gratuit" },
          { key: "home.hero.cta2", label: "Bouton secondaire", type: "text", default: "Découvrir nos solutions" },
        ],
      },
      {
        name: "Trois piliers",
        fields: [
          { key: "home.pillar1.title", label: "Pilier 1 — titre", type: "text", default: "Indépendant" },
          { key: "home.pillar1.body", label: "Pilier 1 — texte", type: "text", default: "Aucune appartenance à un assureur unique" },
          { key: "home.pillar2.title", label: "Pilier 2 — titre", type: "text", default: "Sur mesure" },
          { key: "home.pillar2.body", label: "Pilier 2 — texte", type: "text", default: "Une solution par client, pas un produit standardisé" },
          { key: "home.pillar3.title", label: "Pilier 3 — titre", type: "text", default: "Local" },
          { key: "home.pillar3.body", label: "Pilier 3 — texte", type: "text", default: "Présence et accompagnement à Dijon" },
        ],
      },
      {
        name: "Section « Le cabinet »",
        fields: [
          { key: "home.cabinet.image", label: "Photo (Michelo Nuzzo)", type: "image", default: "/assets/michelo.jpg" },
          { key: "home.cabinet.eyebrow", label: "Étiquette", type: "text", default: "Le cabinet" },
          { key: "home.cabinet.title.line1", label: "Titre — ligne 1", type: "text", default: "Un courtage patrimonial, ancré à Dijon," },
          { key: "home.cabinet.title.line2", label: "Titre — ligne 2", type: "text", default: "fidèle à ses clients." },
          { key: "home.cabinet.body", label: "Paragraphe principal", type: "textarea", default: "Courtage des Ducs accompagne particuliers, indépendants, dirigeants et entreprises de Bourgogne avec une exigence simple : comprendre profondément votre situation avant de proposer une solution. Pas de catalogue figé, pas de conseil générique — uniquement de l'écoute, de l'analyse et de l'engagement dans la durée." },
          { key: "home.cabinet.bullet1", label: "Point 1", type: "text", default: "Indépendance complète vis-à-vis des assureurs" },
          { key: "home.cabinet.bullet2", label: "Point 2", type: "text", default: "Sélection rigoureuse parmi un réseau de partenaires reconnus" },
          { key: "home.cabinet.bullet3", label: "Point 3", type: "text", default: "Accompagnement de bout en bout : audit, sélection, mise en place, suivi" },
          { key: "home.cabinet.bullet4", label: "Point 4", type: "text", default: "Prise en charge des démarches administratives et résiliations" },
          { key: "home.cabinet.signature.name", label: "Plaque — nom", type: "text", default: "Michelo Nuzzo" },
          { key: "home.cabinet.signature.role", label: "Plaque — rôle", type: "text", default: "Votre interlocuteur dédié" },
        ],
      },
      {
        name: "Services — bloc 3 cartes",
        fields: [
          { key: "home.services.eyebrow", label: "Étiquette", type: "text", default: "Notre univers" },
          { key: "home.services.title", label: "Titre", type: "text", default: "Un éventail complet de solutions patrimoniales et professionnelles." },
          { key: "home.service1.title", label: "Carte 1 — titre", type: "text", default: "Assurances professionnelles" },
          { key: "home.service1.body", label: "Carte 1 — texte", type: "text", default: "Responsabilité civile, RC pro et multirisque pour indépendants, dirigeants, TPE et PME." },
          { key: "home.service2.title", label: "Carte 2 — titre", type: "text", default: "Santé, prévoyance & protection du dirigeant" },
          { key: "home.service2.body", label: "Carte 2 — texte", type: "text", default: "Mutuelle, prévoyance, Madelin, protection des salariés et des indépendants." },
          { key: "home.service3.title", label: "Carte 3 — titre", type: "text", default: "Patrimoine & placements" },
          { key: "home.service3.body", label: "Carte 3 — texte", type: "text", default: "Assurance-vie, immobilier, produits structurés, épargne retraite et salariale — accessible aux particuliers comme aux dirigeants." },
        ],
      },
      {
        name: "Méthode (aperçu)",
        fields: [
          { key: "home.methode.eyebrow", label: "Étiquette", type: "text", default: "La méthode" },
          { key: "home.methode.title", label: "Titre", type: "text", default: "Une démarche en cinq étapes, claire et exigeante." },
          { key: "home.methode.subtitle", label: "Sous-titre", type: "textarea", default: "De la première rencontre à la mise en place, nous suivons un processus structuré pour garantir une recommandation pertinente, justifiable et réellement adaptée." },
          { key: "home.methode.button", label: "Bouton", type: "text", default: "Voir la méthode complète" },
        ],
      },
      {
        name: "Chiffres clés",
        fields: [
          { key: "home.stats.eyebrow", label: "Étiquette", type: "text", default: "Chiffres clés" },
          { key: "home.stats.title", label: "Titre", type: "text", default: "Une approche concrète, mesurable." },
          { key: "home.stats.subtitle", label: "Sous-titre (facultatif)", type: "textarea", default: "Des indicateurs qui reflètent notre exigence et notre réactivité." },
          { key: "home.stat1.value", label: "Chiffre 1 — valeur (ex. 150+)", type: "text", default: "100+" },
          { key: "home.stat1.label", label: "Chiffre 1 — libellé", type: "text", default: "Clients accompagnés" },
          { key: "home.stat1.description", label: "Chiffre 1 — précision", type: "text", default: "Particuliers, indépendants, dirigeants et entreprises en Bourgogne." },
          { key: "home.stat2.value", label: "Chiffre 2 — valeur (ex. 22%)", type: "text", default: "18 %" },
          { key: "home.stat2.label", label: "Chiffre 2 — libellé", type: "text", default: "Économies moyennes" },
          { key: "home.stat2.description", label: "Chiffre 2 — précision", type: "text", default: "Gain moyen constaté après audit et renégociation des contrats existants." },
          { key: "home.stat3.value", label: "Chiffre 3 — valeur (ex. 48 h)", type: "text", default: "48 h" },
          { key: "home.stat3.label", label: "Chiffre 3 — libellé", type: "text", default: "Délai de réponse" },
          { key: "home.stat3.description", label: "Chiffre 3 — précision", type: "text", default: "Rappel garanti sous 48 heures ouvrées à toute demande qualifiée." },
        ],
      },
      {
        name: "Témoignages clients",
        fields: [
          { key: "home.testimonials.eyebrow", label: "Étiquette", type: "text", default: "Ils nous font confiance" },
          { key: "home.testimonials.title", label: "Titre", type: "text", default: "Ce que disent nos clients." },
          { key: "home.testimonials.subtitle", label: "Sous-titre (facultatif)", type: "textarea", default: "Témoignages recueillis auprès de personnes accompagnées par le cabinet. Identités modifiables depuis l'administration." },
          { key: "home.testimonial1.name", label: "Témoin 1 — nom", type: "text", default: "Camille L." },
          { key: "home.testimonial1.role", label: "Témoin 1 — fonction / situation", type: "text", default: "Dirigeante de PME, Beaune" },
          { key: "home.testimonial1.quote", label: "Témoin 1 — citation", type: "textarea", default: "Un audit remarquablement précis. Michelo a identifié deux failles sur mes contrats pro que trois courtiers précédents avaient manquées. Rigueur et sens du conseil." },
          { key: "home.testimonial1.rating", label: "Témoin 1 — note (1-5)", type: "text", default: "5" },
          { key: "home.testimonial2.name", label: "Témoin 2 — nom", type: "text", default: "Antoine R." },
          { key: "home.testimonial2.role", label: "Témoin 2 — fonction / situation", type: "text", default: "Indépendant, Dijon" },
          { key: "home.testimonial2.quote", label: "Témoin 2 — citation", type: "textarea", default: "Prévoyance et Madelin repris de zéro, avec une vraie pédagogie. Je comprends enfin ce que je paie et pourquoi. Prestation très premium pour un courtier local." },
          { key: "home.testimonial2.rating", label: "Témoin 2 — note (1-5)", type: "text", default: "5" },
          { key: "home.testimonial3.name", label: "Témoin 3 — nom", type: "text", default: "Famille D." },
          { key: "home.testimonial3.role", label: "Témoin 3 — fonction / situation", type: "text", default: "Particuliers, Côte-d'Or" },
          { key: "home.testimonial3.quote", label: "Témoin 3 — citation", type: "textarea", default: "Nous cherchions quelqu'un pour structurer notre épargne et nos assurances santé. Approche patiente, transparente — et des économies réelles dès la première année." },
          { key: "home.testimonial3.rating", label: "Témoin 3 — note (1-5)", type: "text", default: "5" },
        ],
      },
      {
        name: "Partenaires (aperçu)",
        fields: [
          { key: "home.partners.eyebrow", label: "Étiquette", type: "text", default: "Nos partenaires" },
          { key: "home.partners.title", label: "Titre", type: "text", default: "Un réseau d'assureurs et de spécialistes reconnus, sélectionnés contrat par contrat." },
          { key: "home.partners.button", label: "Bouton", type: "text", default: "Voir tous nos partenaires" },
        ],
      },
      {
        name: "Bande CTA finale",
        fields: [
          { key: "home.cta.title", label: "Titre", type: "text", default: "Demandez votre audit gratuit." },
          { key: "home.cta.subtitle", label: "Sous-titre", type: "textarea", default: "Un échange confidentiel et sans engagement avec Michelo Nuzzo pour cartographier vos contrats et identifier vos axes d'optimisation." },
          { key: "home.cta.eyebrow", label: "Étiquette", type: "text", default: "Prêt à échanger ?" },
          { key: "home.cta.button1", label: "Bouton primaire", type: "text", default: "Demander un audit gratuit" },
          { key: "home.cta.button2", label: "Bouton secondaire", type: "text", default: "Découvrir nos solutions" },
        ],
      },
    ],
  },

  ...buildServicePage({
    slug: "assurances-pro",
    label: "Assurances professionnelles",
    eyebrow: "Assurances professionnelles",
    titleLine1: "Couvrir votre activité,",
    titleAccent: "sans angle mort.",
    intro: "Une activité professionnelle expose à des risques multiples — civils, matériels, contractuels. Nous identifions les bonnes garanties et les bonnes limites, sans surassurance ni vide de couverture.",
    accent: "Une couverture pensée pour les indépendants, dirigeants, TPE et PME.",
    image: "https://images.unsplash.com/photo-1773678401653-6722e9026d22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxkaWpvbiUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjByb29mfGVufDB8fHx8MTc4MTI3NDU0M3ww&ixlib=rb-4.1.0&q=85",
    bullets: [
      { title: "Responsabilité civile", body: "Protection de votre responsabilité vis-à-vis des tiers : clients, fournisseurs, public." },
      { title: "Responsabilité civile professionnelle", body: "Couverture des dommages causés dans le cadre de votre activité professionnelle, y compris les fautes, erreurs et omissions." },
      { title: "Multirisque professionnelle", body: "Locaux, matériel, perte d'exploitation, marchandises : une protection consolidée des actifs de votre entreprise." },
      { title: "Solutions pour TPE & PME", body: "Audit du portefeuille existant, optimisation des primes, mise en concurrence régulière des compagnies." },
    ],
    cta: "Faisons le point sur votre exposition réelle et vos contrats actuels.",
  }),

  ...buildServicePage({
    slug: "sante-prevoyance",
    label: "Santé, prévoyance & protection",
    eyebrow: "Santé, prévoyance & protection",
    titleLine1: "Protéger ce qui compte :",
    titleAccent: "vous, vos proches, votre équipe.",
    intro: "Mutuelle, prévoyance, contrats Madelin, protection du dirigeant et des salariés : une architecture de protection cohérente, calibrée à votre statut et à votre situation familiale. Nos solutions s'adressent aussi bien aux particuliers qu'aux professionnels.",
    accent: "Une protection sociale conçue comme un patrimoine à part entière.",
    image: "https://images.unsplash.com/photo-1653502218528-de58ba1c9039?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxkaWpvbiUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjByb29mfGVufDB8fHx8MTc4MTI3NDU0M3ww&ixlib=rb-4.1.0&q=85",
    bullets: [
      { title: "Mutuelle santé (particuliers & collectifs)", body: "Couverture santé individuelle ou collective, adaptée à vos besoins réels — soins courants, hospitalisation, optique, dentaire." },
      { title: "Prévoyance", body: "Maintien de revenu en cas d'arrêt de travail, capital décès, rente d'invalidité — un filet essentiel pour la famille comme pour l'entreprise." },
      { title: "Protection des salariés", body: "Mise en conformité conventionnelle, négociation des contrats collectifs, qualité des garanties." },
      { title: "Protection des indépendants & contrat Madelin", body: "Optimisation fiscale et garanties cohérentes avec votre statut TNS." },
      { title: "Protection du dirigeant", body: "Homme-clé, indemnités journalières, rente conjoint : sécuriser l'entreprise au-delà du dirigeant." },
    ],
    cta: "Auditez vos contrats santé et prévoyance — un domaine où les écarts sont les plus coûteux.",
  }),

  ...buildServicePage({
    slug: "patrimoine",
    label: "Patrimoine & placements",
    eyebrow: "Patrimoine & placements",
    titleLine1: "Faire fructifier",
    titleAccent: "avec mesure et lisibilité.",
    intro: "Le patrimoine se construit dans la durée. Notre approche est prudente, lisible et orientée objectifs : retraite, transmission, complément de revenus, projets de vie. Nos solutions sont ouvertes aux particuliers — quel que soit le montant de votre épargne — comme aux dirigeants et aux professionnels.",
    accent: "Un conseil patrimonial sobre, indépendant et tourné vers le long terme, accessible aux particuliers comme aux dirigeants.",
    image: "https://images.unsplash.com/photo-1493934558415-9d19f0b2b4d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHx3ZWFsdGglMjBtYW5hZ2VtZW50JTIwY29uc3VsdGF0aW9uJTIwZGVza3xlbnwwfHx8fDE3ODEyNzQ1NDN8MA&ixlib=rb-4.1.0&q=85",
    bullets: [
      { title: "Pour les particuliers", body: "Que vous commenciez à épargner, prépariez un projet immobilier ou organisiez votre retraite, nous construisons une stratégie patrimoniale sobre et adaptée à votre horizon." },
      { title: "Assurance-vie", body: "Le contrat patrimonial par excellence : épargne disponible, fiscalité avantageuse, transmission optimisée. Accessible à partir de montants modestes." },
      { title: "Produits immobiliers", body: "SCPI, SCI, foncières — une exposition immobilière diversifiée, sans contrainte de gestion, ouverte aux particuliers." },
      { title: "Produits structurés", body: "Solutions de rendement à profil maîtrisé, sélectionnées dans une logique de complément de portefeuille." },
      { title: "Épargne retraite", body: "PER individuel (particuliers, indépendants) et collectif : préparer sereinement la retraite tout en bénéficiant d'avantages fiscaux." },
      { title: "Épargne salariale", body: "Mise en place et optimisation des dispositifs PEE, PERCOL — un levier d'attractivité et de fidélisation pour les entreprises." },
    ],
    cta: "Particulier ou dirigeant, construisons une stratégie patrimoniale cohérente avec vos projets de vie.",
  }),

  {
    slug: "methode",
    label: "Méthode",
    description: "Page détaillée de la méthode en 5 étapes.",
    sections: [
      {
        name: "Hero",
        fields: [
          { key: "methode.hero.eyebrow", label: "Étiquette", type: "text", default: "Notre méthode" },
          { key: "methode.hero.title.line1", label: "Titre — ligne 1", type: "text", default: "Cinq étapes pour transformer un besoin diffus" },
          { key: "methode.hero.title.accent", label: "Titre — accent", type: "text", default: "en couverture précise." },
          { key: "methode.hero.intro", label: "Paragraphe d'introduction", type: "textarea", default: "Une démarche structurée, transparente et exigeante. Chaque étape se conclut par une décision claire, partagée avec vous." },
        ],
      },
      ...[1, 2, 3, 4, 5].map((i) => ({
        name: `Étape ${i}`,
        fields: [
          { key: `methode.step${i}.number`, label: `Étape ${i} — numéro affiché`, type: "text", default: `0${i}` },
          { key: `methode.step${i}.title`, label: `Étape ${i} — titre`, type: "text", default: [
            "Audit de votre situation",
            "Analyse fine de vos besoins",
            "Sélection d'offres adaptées",
            "Ajustement sur mesure",
            "Mise en place complète",
          ][i - 1] },
          { key: `methode.step${i}.body`, label: `Étape ${i} — description`, type: "textarea", default: [
            "Un premier échange approfondi pour comprendre votre contexte, vos contrats existants et vos objectifs.",
            "Étude de vos besoins personnels, professionnels et patrimoniaux pour cartographier les couvertures pertinentes.",
            "Comparaison rigoureuse parmi notre réseau de partenaires reconnus pour ne retenir que les solutions qui vous correspondent.",
            "Ajustement contradictoire avec vous : garanties, franchises, options. Une solution réellement à votre image.",
            "Souscription, démarches administratives, résiliation des anciens contrats si nécessaire : nous nous occupons de tout.",
          ][i - 1] },
        ],
      })),
      {
        name: "Bande CTA",
        fields: [
          { key: "methode.cta.eyebrow", label: "Étiquette", type: "text", default: "Prêt à échanger ?" },
          { key: "methode.cta.title", label: "Titre", type: "text", default: "Commençons par l'étape 1 : l'audit." },
          { key: "methode.cta.subtitle", label: "Sous-titre", type: "textarea", default: "Un audit confidentiel et sans engagement pour cartographier vos contrats existants." },
          { key: "methode.cta.button1", label: "Bouton primaire", type: "text", default: "Demander un audit gratuit" },
          { key: "methode.cta.button2", label: "Bouton secondaire", type: "text", default: "Nous contacter" },
        ],
      },
    ],
  },

  {
    slug: "partenaires",
    label: "Partenaires",
    description: "Page de présentation du réseau de partenaires.",
    sections: [
      {
        name: "Hero",
        fields: [
          { key: "partenaires.hero.eyebrow", label: "Étiquette", type: "text", default: "Nos partenaires" },
          { key: "partenaires.hero.title.line1", label: "Titre — ligne 1", type: "text", default: "Un réseau d'assureurs reconnus," },
          { key: "partenaires.hero.title.accent", label: "Titre — accent", type: "text", default: "sélectionnés contrat par contrat." },
          { key: "partenaires.hero.intro", label: "Paragraphe d'introduction", type: "textarea", default: "Courtage des Ducs sélectionne, compare et ajuste ses recommandations auprès d'un réseau de partenaires reconnus dans l'assurance, la santé, la prévoyance et les solutions patrimoniales. Cette diversité permet de proposer des réponses adaptées à chaque situation, sans solution standardisée." },
        ],
      },
      {
        name: "Bande CTA",
        fields: [
          { key: "partenaires.cta.eyebrow", label: "Étiquette", type: "text", default: "Prêt à échanger ?" },
          { key: "partenaires.cta.title", label: "Titre", type: "text", default: "Bénéficiez de cette indépendance." },
          { key: "partenaires.cta.subtitle", label: "Sous-titre", type: "textarea", default: "Nous comparons ces partenaires pour identifier la meilleure offre selon votre situation." },
          { key: "partenaires.cta.button1", label: "Bouton primaire", type: "text", default: "Demander un audit gratuit" },
          { key: "partenaires.cta.button2", label: "Bouton secondaire", type: "text", default: "Découvrir nos solutions" },
        ],
      },
    ],
  },

  {
    slug: "contact",
    label: "Contact",
    description: "Page de contact et formulaire de demande.",
    sections: [
      {
        name: "Hero",
        fields: [
          { key: "contact.hero.eyebrow", label: "Étiquette", type: "text", default: "Prendre contact" },
          { key: "contact.hero.title.line1", label: "Titre — ligne 1", type: "text", default: "Parlons de votre situation," },
          { key: "contact.hero.title.accent", label: "Titre — accent", type: "text", default: "en toute confidentialité." },
          { key: "contact.hero.intro", label: "Paragraphe d'introduction", type: "textarea", default: "Un échange de 20 à 30 minutes avec Michelo Nuzzo suffit pour identifier vos axes d'optimisation. Sans engagement." },
        ],
      },
      {
        name: "Bloc latéral (coordonnées)",
        fields: [
          { key: "contact.aside.eyebrow", label: "Étiquette", type: "text", default: "Cabinet" },
          { key: "contact.aside.name", label: "Nom du cabinet", type: "text", default: "Courtage des Ducs" },
          { key: "contact.aside.role", label: "Identité dirigeant", type: "text", default: "Michelo Nuzzo — Dirigeant" },
          { key: "contact.aside.location", label: "Localisation", type: "text", default: "Dijon, Bourgogne-Franche-Comté" },
          { key: "contact.aside.email", label: "Email affiché", type: "text", default: "contact@courtagedesducs.fr" },
          { key: "contact.aside.phone", label: "Téléphone / disponibilité", type: "text", default: "Rendez-vous téléphoniques ou en cabinet" },
          { key: "contact.aside.note.label", label: "Encadré — titre", type: "text", default: "Engagement" },
          { key: "contact.aside.note.text", label: "Encadré — texte", type: "textarea", default: "Votre demande est traitée en toute confidentialité. Nous vous recontactons sous 48 h ouvrées." },
        ],
      },
      {
        name: "Formulaire",
        fields: [
          { key: "contact.form.submit", label: "Bouton d'envoi", type: "text", default: "Envoyer ma demande" },
          { key: "contact.form.rgpd", label: "Texte mention RGPD", type: "textarea", default: "J'accepte que mes informations soient utilisées par Courtage des Ducs pour me recontacter dans le cadre de ma demande. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données." },
          { key: "contact.form.success", label: "Message après envoi (toast)", type: "text", default: "Votre demande a bien été transmise. Michelo Nuzzo vous recontactera rapidement." },
          { key: "contact.form.placeholder", label: "Placeholder du message", type: "textarea", default: "Décrivez brièvement votre situation, vos contrats actuels, vos objectifs…" },
        ],
      },
    ],
  },
];

function buildServicePage({ slug, label, eyebrow, titleLine1, titleAccent, intro, accent, image, bullets, cta }) {
  return [{
    slug,
    label,
    description: `Page service : ${label}.`,
    sections: [
      {
        name: "Hero",
        fields: [
          { key: `${slug}.hero.eyebrow`, label: "Étiquette", type: "text", default: eyebrow },
          { key: `${slug}.hero.title.line1`, label: "Titre — ligne 1", type: "text", default: titleLine1 },
          { key: `${slug}.hero.title.accent`, label: "Titre — accent", type: "text", default: titleAccent },
          { key: `${slug}.hero.intro`, label: "Paragraphe d'introduction", type: "textarea", default: intro },
          { key: `${slug}.hero.image`, label: "Image", type: "image", default: image },
          { key: `${slug}.hero.cta1`, label: "Bouton primaire", type: "text", default: "Demander un audit" },
          { key: `${slug}.hero.cta2`, label: "Bouton secondaire", type: "text", default: "Notre méthode" },
        ],
      },
      {
        name: "Section principale",
        fields: [
          { key: `${slug}.body.eyebrow`, label: "Étiquette", type: "text", default: "Notre approche" },
          { key: `${slug}.body.accent`, label: "Sous-titre", type: "textarea", default: accent },
          ...bullets.flatMap((b, i) => [
            { key: `${slug}.bullet${i + 1}.title`, label: `Point ${i + 1} — titre`, type: "text", default: b.title },
            { key: `${slug}.bullet${i + 1}.body`, label: `Point ${i + 1} — texte`, type: "textarea", default: b.body },
          ]),
        ],
      },
      {
        name: "Bande CTA inférieure",
        fields: [
          { key: `${slug}.cta.label`, label: "Étiquette", type: "text", default: "Prochaine étape" },
          { key: `${slug}.cta.title`, label: "Titre", type: "text", default: cta },
          { key: `${slug}.cta.button`, label: "Bouton", type: "text", default: "Être rappelé" },
        ],
      },
    ],
  }];
}

export const DEFAULTS = {};
PAGES.forEach((p) => p.sections.forEach((s) => s.fields.forEach((f) => { DEFAULTS[f.key] = f.default; })));

export const SERVICE_BULLET_COUNT = {
  "assurances-pro": 4,
  "sante-prevoyance": 5,
  "patrimoine": 6,
};
